import { Edit, RecordField, SimpleForm } from "@/components/admin"
import { HardHat, Proportions, TextCursorInput } from "lucide-react"
import Overview from "./components/edit-overview"
import Taskforce from "./components/edit-taskforce"
import Workspace from "./components/edit-workspace"

import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { RaRecord, useGetIdentity } from "ra-core"
import { ReactElement } from "react"
import ProjectHeader from "./components/project-header"
const ProjectCreate = (): ReactElement => {
  const { data: identity } = useGetIdentity()

  const tabs = [
    {
      name: "Workspace",
      value: 0,
      icon: Proportions,
    },
    {
      name: "Inputs",
      value: 1,
      icon: TextCursorInput,
    },

    {
      name: "Taskforce",
      value: 2,
      icon: HardHat,
    },
  ]

  return (
    <Edit
      actions={false}
      mutationMode="optimistic"
      title=""
      redirect="edit"
      transform={(data: RaRecord) => ({
        ...data,
        client_id: identity?.id,
        updated_at: new Date().toISOString(),
        updated_by: identity?.id,
      })}
    >
      <SimpleForm>
        <RecordField
          render={({
            id,
            title,
            status,
            city,
            region,
            floors,
            surface,
            bedrooms,
          }) => (
            <ProjectHeader
              mode="edit"
              showProgress
              {...{
                id,
                title,
                status,
                city,
                region,
                floors,
                surface,
                bedrooms,
              }}
            />
          )}
        />
        <Tabs defaultValue="0">
          <ScrollArea className="w-full whitespace-nowrap">
            <TabsList className="grid w-full grid-cols-3 h-fit rounded-md bg-secondary ">
              {tabs.map(({ icon: Icon, name, value }) => (
                <TabsTrigger
                  key={value}
                  value={value.toString()}
                  className="cursor-pointer flex flex-col items-center gap-2  rounded-md data-[state=active]:bg-primary dark:data-[state=active]:bg-primary data-[state=active]:text-primary-foreground dark:data-[state=active]:text-primary-foreground dark:data-[state=active]:border-transparent"
                >
                  <Icon />
                  <div>{name}</div>
                </TabsTrigger>
              ))}
            </TabsList>
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
          <TabsContent key={0} value="0">
            <Workspace />
          </TabsContent>
          <TabsContent key={1} value="1">
            <Overview />
          </TabsContent>
          <TabsContent key={2} value="2">
            <Taskforce />
          </TabsContent>
        </Tabs>
      </SimpleForm>
    </Edit>
  )
}

export default ProjectCreate
